<template>
  <div class="home">
    <div>
      <div class="list">
        <div class="title">
          <div>首页新闻</div>
          <div></div>
          <div @click="$router.push('newslist')">更多...</div>
        </div>
        <List>
          <ListItem v-for="(item, i) in newsArr" @click.native="$router.push('newslist/details?id=' + item.id)" :key='i'
            v-show="i < 5">
            <span></span>{{ item.title }}
          </ListItem>
        </List>
      </div>
      <div class="list">
        <div class="title">
          <div>通知公告</div>
          <div></div>
          <div @click="$router.push('noticeList')">更多...</div>
        </div>
        <List>
          <ListItem v-for="(itemb, i) in noticeArr" @click.native="$router.push('noticeList/details?id=' + itemb.id)"
            :key='i' v-show="i < 5">
            <span></span>{{ itemb.name }}
          </ListItem>
        </List>
      </div>
      <div class="list">
        <div class="title">
          <div>名师推荐</div>
          <div></div>
          <div @click="$router.push('teacherList')">更多...</div>
        </div>
        <div class="teachers">
          <div class="teacher" v-for="(itemc, n) in teacherArr"
            @click="$router.push('teacherList/details?id=' + itemc.id)" :key="n">
            <img :src="path + itemc.avatar" />
            <div>{{ itemc.real_name }}</div>
            <div>{{ itemc.curse_title }}</div>
            <!-- <div>毕业于山东省青岛大学{{itemc.campus}}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "home",
    components: {},
    data() {
      return {
        info: {},
        noticeArr: [],
        teacherArr: [],
        newsArr: []
      };
    },
    created() {
      this.getData();
    },
    mounted() { },
    methods: {
      getData() {
        var that = this;
        that.teacherArr = []
        that.noticeArr = []
        that.newsArr = []
        that.$axios.get("/app/teacher/index?is_recommend=2").then((res) => {
          if (res.code == 1) {
            that.teacherArr = res.data.data;
          } else {
            that.$Message.error(res.msg);
          }
        });
        that.$axios.get("/app/news/index").then((res) => {
          if (res.code == 1) {
            that.newsArr = res.data.data;
          } else {
            that.$Message.error(res.msg);
          }
        });
        that.$axios.get("/app/notice_relation/index").then((res) => {
          if (res.code == 1) {
            that.noticeArr = res.data.data;
          } else {
            that.$Message.error(res.msg);
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .home {
    width: 90%;
    margin: 0px auto;
    .ivu-card {
      border-radius: 10px;
      margin: 10px 0;
    }
    .list {
      width: 100%;
      margin-bottom: 20px;
      .title {
        display: flex;
        position: relative;
        width: 100%;
        border-bottom: 1px solid rgb(224, 224, 224);
        padding-bottom: 10px;
        div:nth-child(1) {
          width: 90px;
          font-size: 18px;
          border-bottom: 3px solid tomato;
          padding-left: 12px;
          font-weight: bold;
        }
        div:nth-child(2) {
          position: relative;
          top: 9px;
        }
        div:nth-child(3) {
          position: absolute;
          right: 5%;
          margin-top: 10px;
          cursor: pointer;
        }
      }
      /deep/.ivu-list-items {
        margin-top: 10px;
        cursor: pointer;
      }
      .ivu-list-item {
        span {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background: rgb(255, 196, 2);
          margin-right: 5px;
        }
      }
    }
    .box {
      width: 100%;
      height: 16vh;
      background: #fff;
      border-radius: 20px;
      margin-bottom: 2vh;
      .top {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        >img {
          width: 30px;
          height: 30px;
        }
        span {
          color: #000;
          font-size: 19px;
          margin-left: 20px;
        }
      }
      p {
        width: 100%;
        padding: 8px 30px;
        font-size: 20px;
        color: #333;
        display: flex;
        justify-content: space-between;
      }
    }
    .teachers {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .teacher {
        cursor: pointer;
        width: 195px;
        min-height: 220px;
        background: #fff;
        text-align: center;
        box-shadow: #c7c7c7 0px 0px 18px;
        margin: 10px;
        padding: 0 0 10px 0;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 220px;
          margin: 0 auto 10px;
          object-fit: contain;
        }
        p {
          color: #000;
          font-size: 14px;
        }
      }
    }
  }
</style>
